import MatAccordionDetails from '@material-ui/core/AccordionDetails'

export const AccordionDetails = MatAccordionDetails
